import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Link } from 'foundations-components/transitional/components/Link';
import getPropertyValue from '../dataAccessHelpers/getPropertyValue';
import StyledProperty from './stylingComponents/StyledProperty';
import { jsx as _jsx } from "react/jsx-runtime";
const MaybeExternalPaymentLink = ({
  properties,
  externalAccountId,
  externalPaymentUrl,
  paymentIntentId
}) => {
  const paymentCreationMethod = getPropertyValue(properties, 'hs_payment_creation_method');
  const processorType = getPropertyValue(properties, 'hs_processor_type');
  const externalUrl = externalPaymentUrl || (paymentCreationMethod === 'PAYMENTS_PROCESSOR' && processorType === 'byo_stripe' ? `https://dashboard.stripe.com/${externalAccountId}/payments/${paymentIntentId}` : null);
  const getLinkText = () => {
    const viewExternalPaymentLinkKey = `cardPaymentHighlight.paymentHighlight.viewExternalPaymentLink.${processorType}`;
    if (isValidI18nKey(viewExternalPaymentLinkKey)) {
      return viewExternalPaymentLinkKey;
    }
    return 'cardPaymentHighlight.paymentHighlight.viewExternalPaymentLink.default';
  };
  if (!externalUrl) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledProperty, {
    children: /*#__PURE__*/_jsx(Link, {
      href: externalUrl,
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getLinkText()
      })
    })
  });
};
export default MaybeExternalPaymentLink;